module.exports = __webpack_public_path__ + "img/11.03418bfc.png";